import { render, staticRenderFns } from "./productPhoto.vue?vue&type=template&id=640a265b&"
import script from "./productPhoto.vue?vue&type=script&lang=js&"
export * from "./productPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports